/* Genie NO — theme behaviour
   Everything is progressive: if JS fails the page still reads and the
   native product form still submits. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function pad(n) { return String(n).padStart(2, '0'); }

  /* ---------- Accordions ---------- */
  function initAccordions(root) {
    $$('.accordion__trigger', root).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      var panel = btn.nextElementSibling;
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      panel.style.height = open ? 'auto' : '0px';

      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

        if (isOpen) {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () { panel.style.height = '0px'; });
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          panel.addEventListener('transitionend', function once() {
            panel.style.height = 'auto';
            panel.removeEventListener('transitionend', once);
          });
        }
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGalleries(root) {
    $$('[data-gallery]', root).forEach(function (gallery) {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = '1';

      var main = $('[data-gallery-main]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      if (!main || !thumbs.length) return;

      var index = 0;
      var frame = main.parentElement;
      var track = document.createElement('div');
      track.className = 'gallery-track';
      thumbs.forEach(function (t, i) {
        var img = document.createElement('img');
        img.src = i === 0 ? main.src : t.dataset.full;
        img.alt = main.alt || '';
        img.draggable = false;
        if (i > 0) img.loading = 'lazy';
        track.appendChild(img);
      });
      main.hidden = true;
      frame.insertBefore(track, main);

      function syncThumbs() {
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
        var strip = thumbs[index].parentElement, t = thumbs[index];
        if (strip && strip.scrollWidth > strip.clientWidth) {
          strip.scrollTo({ left: t.offsetLeft - strip.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        }
      }

      var target = null, targetTimer;
      function go(n) {
        index = (n + thumbs.length) % thumbs.length;
        target = index;
        clearTimeout(targetTimer);
        targetTimer = setTimeout(function () { target = null; }, 1200);
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
        syncThumbs();
      }

      var ticking = false;
      track.addEventListener('touchstart', function () { target = null; }, { passive: true });
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (target !== null) { if (i === target) target = null; return; }
          if (i !== index && i >= 0 && i < thumbs.length) { index = i; syncThumbs(); }
        });
      }, { passive: true });

      var prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
      if (thumbs.length < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; }
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { go(i); });
      });
    });
  }

  /* ---------- Bundle selector ---------- */
  function formatKr(cents) {
    return Math.round(cents / 100).toLocaleString('sv-SE') + ' kr';
  }
  function krToCents(text) {
    var n = parseInt(String(text).replace(/[^\d]/g, ''), 10);
    return isNaN(n) ? 0 : n * 100;
  }

  function initBundles(root) {
    $$('[data-bundle]', root).forEach(function (bundle) {
      if (bundle.dataset.bound) return;
      bundle.dataset.bound = '1';

      var qtyInput = $('[data-bundle-qty]');
      var options = $$('[data-bundle-option]', bundle);

      function select(opt) {
        options.forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        if (qtyInput) qtyInput.value = opt.dataset.qty || 1;
        /* Each bundle maps to its own variant, so the price is the variant's. */
        var idInput = $('[data-product-form] input[name="id"]');
        if (idInput && opt.dataset.variantId) idInput.value = opt.dataset.variantId;

        var price = opt.dataset.price || '';
        var compare = opt.dataset.compare || '';

        /* A ticked add-on under this pack is added to the shown price. */
        var optItem = opt.closest('.bundle__item');
        var tick = optItem && optItem.querySelector('[data-addon-input]:checked');
        if (tick && opt.dataset.priceCents) {
          var extra = Number(tick.dataset.addonCents || 0);
          price = formatKr(Number(opt.dataset.priceCents) + extra);
          if (compare) compare = formatKr(krToCents(compare) + extra);
        }
        $$('[data-live-price]').forEach(function (el) { el.textContent = price; });
        $$('[data-live-compare]').forEach(function (el) {
          el.textContent = compare;
          el.style.display = compare ? '' : 'none';
        });

        /* Progress bar: fill up to the chosen offer's step. */
        var index = options.indexOf(opt);
        $$('[data-offer-progress]').forEach(function (bar) {
          var steps = $$('[data-offer-progress-step]', bar);
          if (!steps.length) return;
          var step = Math.min(index, steps.length - 1);
          var fill = $('[data-offer-progress-fill]', bar);
          if (fill) fill.style.width = (steps.length > 1 ? (step / (steps.length - 1)) * 100 : 100) + '%';
          steps.forEach(function (s, i) { s.classList.toggle('is-done', i <= step); });
          var msg = $('[data-offer-progress-msg]', bar);
          var text = bar.getAttribute('data-msg-' + (step + 1));
          if (msg && text) msg.textContent = text;
        });
      }

      options.forEach(function (opt) {
        opt.addEventListener('click', function () { select(opt); });
        /* Ticking the add-on under a pack also picks that pack. */
        var item = opt.closest('.bundle__item');
        var addonInput = item && item.querySelector('[data-addon-input]');
        if (addonInput) {
          addonInput.addEventListener('change', function () {
            if (addonInput.checked || opt.classList.contains('is-active')) select(opt);
          });
        }
      });

      var preselected = options.filter(function (o) { return o.classList.contains('is-active'); })[0];
      if (preselected) select(preselected);
    });
  }

  /* ---------- Rolling countdown ----------
     Keeps a per-visitor deadline in localStorage so the timer does not
     reset on every page view, and rolls over once it expires. */
  function initCountdowns(root) {
    $$('[data-countdown]', root).forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';

      var hours = parseFloat(el.dataset.hours || '6');
      var span = hours * 3600000;
      var key = 'genie-cd-' + hours;
      var target;
      var fixedEnd = el.dataset.end ? Date.parse(el.dataset.end) : NaN;

      if (!isNaN(fixedEnd)) {
        target = fixedEnd;
      } else try {
        target = parseInt(window.localStorage.getItem(key) || '0', 10);
        if (!target || target < Date.now()) {
          target = Date.now() + span;
          window.localStorage.setItem(key, String(target));
        }
      } catch (e) {
        target = Date.now() + span;
      }

      var dd = $('[data-cd-dd]', el);
      var hh = $('[data-cd-hh]', el);
      var mm = $('[data-cd-mm]', el);
      var ss = $('[data-cd-ss]', el);

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0 && !isNaN(fixedEnd)) {
          diff = 0;
        } else if (diff <= 0) {
          target = Date.now() + span;
          try { window.localStorage.setItem(key, String(target)); } catch (e) {}
          diff = span;
        }
        /* With a days cell the hours roll over at 24; without one they keep
           counting up, so a 2-day timer still reads correctly either way. */
        if (dd) {
          dd.textContent = pad(Math.floor(diff / 86400000));
          hh.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        } else if (hh) {
          hh.textContent = pad(Math.floor(diff / 3600000));
        }
        if (mm) mm.textContent = pad(Math.floor((diff % 3600000) / 60000));
        if (ss) ss.textContent = pad(Math.floor((diff % 60000) / 1000));
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu(root) {
    $$('[data-menu-toggle]', root).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = panel.hasAttribute('data-open');
        if (open) { panel.removeAttribute('data-open'); } else { panel.setAttribute('data-open', ''); }
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  /* ---------- Add to cart ---------- */
  function initProductForm(root) {
    $$('[data-product-form]', root).forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';

      /* No real variant behind the form (product not created yet) —
         let the merchant still see the page without a broken POST. */
      if (!form.querySelector('input[name="id"]').value) {
        form.addEventListener('submit', function (e) { e.preventDefault(); });
        return;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var label = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Lägger i varukorgen…'; }

        var items = [{
          id: Number(form.querySelector('input[name="id"]').value),
          quantity: Number(form.querySelector('[data-bundle-qty]').value || 1)
        }];
        /* Add-on ticked on the chosen pack goes into the cart too. */
        var active = $('[data-bundle-option].is-active');
        var item = active && active.closest('.bundle__item');
        var addon = item && item.querySelector('[data-addon-input]:checked');
        if (addon && addon.value) items.push({ id: Number(addon.value), quantity: 1 });
        /* Pack with a free gift (made free by an automatic discount). */
        if (active && active.dataset.giftVariant) items.push({ id: Number(active.dataset.giftVariant), quantity: 1 });
        if (active && active.dataset.gift2Variant) items.push({ id: Number(active.dataset.gift2Variant), quantity: 1 });

        CartDrawer.addItems(items)
          .then(function () {
            if (btn) { btn.disabled = false; btn.innerHTML = label; }
            CartDrawer.open();
          })
          .catch(function () {
            /* Nettet svikta — la handlekurvsiden ta over i stedet for a sla feil. */
            if (btn) { btn.disabled = false; btn.innerHTML = label; }
            window.location.href = '/cart';
          });
      });
    });
  }

  /* ---------- Sticky add to cart on phones ---------- */
  function initStickyAtc(root) {
    var bar = $('[data-sticky-atc]', root);
    var form = $('[data-product-form]');
    if (!bar || !form) return;
    if (bar.dataset.bound) return;
    bar.dataset.bound = '1';

    var anchor = $('[data-atc-anchor]');
    if (!anchor) return;

    /* Show the bar once the real buy button has scrolled up out of view. */
    function update() {
      var show = anchor.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('has-sticky-atc', show);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    $('[data-sticky-submit]', bar).addEventListener('click', function () {
      if (form.requestSubmit) { form.requestSubmit(); }
      else { form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
    });
  }

  /* ---------- Back to top arrow ---------- */
  function initToTop() {
    var btn = $('[data-to-top]');
    if (!btn || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    function update() { btn.classList.toggle('is-visible', window.scrollY > 1500); }
    window.addEventListener('scroll', update, { passive: true });
    update();
    btn.addEventListener('click', function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* ---------- Show more reviews ---------- */
  function initReviewsMore(root) {
    $$('[data-reviews-more]', root).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        $$('[data-review-hidden]').forEach(function (el) {
          el.removeAttribute('hidden');
          el.removeAttribute('data-review-hidden');
        });
        btn.remove();
      });
    });
  }

  /* ---------- Section videos ----------
     They are set to preload="none", so nothing downloads until the clip is
     near the viewport. Off-screen clips are paused again to keep a page full
     of them from eating bandwidth and battery. */
  function initSectionVideos(root) {
    var videos = $$('.media-video', root);
    if (!videos.length) return;

    function play(v) {
      var p = v.play();
      /* Autoplay can still be refused (data saver, low power mode). Falling
         back to the poster frame is fine — it just stops looking animated. */
      if (p && p.catch) p.catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { if (!v.dataset.bound) { v.dataset.bound = '1'; play(v); } });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { play(entry.target); }
        else { entry.target.pause(); }
      });
    }, { rootMargin: '200px 0px' });

    videos.forEach(function (v) {
      if (v.dataset.bound) return;
      v.dataset.bound = '1';
      /* Belt and braces: the attribute alone is not always enough on iOS. */
      v.muted = true;
      v.removeAttribute('controls');
      io.observe(v);
    });
  }

  /* ---------- Popups (native <dialog>) and tabs ---------- */
  /* Safari can skip lazy images inside a closed dialog, so load them when it opens.
     Old phones without showModal get the dialog shown with a class instead. */
  function openModal(dialog) {
    if (!dialog || dialog.open) return;
    $$('img[loading="lazy"]', dialog).forEach(function (img) { img.loading = 'eager'; });
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else { dialog.setAttribute('open', ''); dialog.classList.add('modal--fallback'); document.documentElement.classList.add('has-modal'); }
  }
  function closeModal(dialog) {
    if (typeof dialog.close === 'function') dialog.close();
    else { dialog.removeAttribute('open'); dialog.classList.remove('modal--fallback'); document.documentElement.classList.remove('has-modal'); }
  }

  function initModals(root) {
    $$('[data-modal-open]', root).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        openModal(document.getElementById(btn.dataset.modalOpen));
      });
    });

    $$('[data-modal]', root).forEach(function (dialog) {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = '1';
      /* A click that lands on the dialog itself, not its content, is the backdrop. */
      dialog.addEventListener('click', function (e) { if (e.target === dialog) closeModal(dialog); });
      $$('[data-modal-close]', dialog).forEach(function (c) {
        c.addEventListener('click', function () { closeModal(dialog); });
      });
    });

    $$('[data-tabs]', root).forEach(function (tabs) {
      if (tabs.dataset.bound) return;
      tabs.dataset.bound = '1';
      var buttons = $$('[data-tab]', tabs);
      var panels = $$('[data-tab-panel]', tabs);
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) { p.hidden = p.dataset.tabPanel !== btn.dataset.tab; });
        });
      });
    });
  }

  /* ---------- Announcement bar: switch between slides ---------- */
  function initAnnounceRotate(root) {
    $$('[data-announce-rotate]', root).forEach(function (bar) {
      if (bar.dataset.bound) return;
      bar.dataset.bound = '1';
      var slides = $$('.announce__slide', bar);
      if (slides.length < 2) return;
      var ms = Math.max(2, parseFloat(bar.dataset.interval || '5')) * 1000;
      var i = 0;
      setInterval(function () {
        if (document.hidden) return;
        slides[i].classList.remove('is-active');
        slides[i].setAttribute('aria-hidden', 'true');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
        slides[i].removeAttribute('aria-hidden');
      }, ms);
    });
  }

  /* ---------- Feature tabs: media + tab bar + caption ---------- */
  function initFeatureTabs(root) {
    $$('[data-ftabs]', root).forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';

      var tabs = $$('[data-ftab]', el);
      var slides = $$('[data-ftab-slide]', el);
      var texts = $$('[data-ftab-text]', el);
      var bar = $('[data-ftab-bar]', el);
      if (!tabs.length) return;
      var index = 0;

      function go(n) {
        index = (n + tabs.length) % tabs.length;
        tabs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === index);
          t.setAttribute('aria-selected', k === index ? 'true' : 'false');
        });
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === index); });
        texts.forEach(function (s, k) { s.classList.toggle('is-active', k === index); });

        /* On phones the bar scrolls; keep the active tab centred in it. */
        var t = tabs[index];
        if (bar && bar.scrollWidth > bar.clientWidth) {
          bar.scrollTo({ left: t.offsetLeft - (bar.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        }
      }

      tabs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var prev = $('[data-ftab-prev]', el);
      var next = $('[data-ftab-next]', el);
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });

      el.ftabGo = go;
    });
  }

  /* Theme editor: selecting a tab block shows that tab. */
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-ftab-slide]');
    var stage = slide && slide.closest('[data-ftabs]');
    if (stage && stage.ftabGo) stage.ftabGo(parseInt(slide.dataset.ftabSlide, 10));
  });

  /* ---------- Setup steps: swipe on touch, drag with a mouse, dots ---------- */
  function initSetupSteps(root) {
    $$('[data-setup-track]', root).forEach(function (track) {
      if (track.dataset.bound) return;
      track.dataset.bound = '1';

      var steps = $$('[data-setup-step]', track);
      var section = track.parentNode;
      var dots = $$('[data-setup-dot]', section);

      function nearest() {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        steps.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }

      function scrollToStep(i) {
        var s = steps[i];
        if (!s) return;
        track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: 'smooth' });
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var n = nearest();
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === n); });
          ticking = false;
        });
      }, { passive: true });

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          /* Mark it straight away; the scroll handler confirms once the snap settles. */
          dots.forEach(function (x, k) { x.classList.toggle('is-active', k === i); });
          scrollToStep(i);
        });
      });

      /* Mouse drag — touch devices already swipe natively. */
      var down = false, startX = 0, startLeft = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || track.scrollWidth <= track.clientWidth) return;
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
        if (moved) scrollToStep(nearest());
      });
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* Theme editor: selecting an "ideal for" block opens its popup, on the
     right tab, so the merchant can see the item they are editing. */
  document.addEventListener('shopify:block:select', function (e) {
    if (!e.target.closest) return;

    var chip = e.target.closest('[data-modal-open]');
    if (chip) {
      var own = document.getElementById(chip.dataset.modalOpen);
      if (own && own.showModal && !own.open) own.showModal();
      return;
    }

    var item = e.target.closest('.ideallist__item');
    if (!item) return;
    var dialog = item.closest('dialog[data-modal]');
    if (dialog && dialog.showModal && !dialog.open) dialog.showModal();
    var panel = item.closest('[data-tab-panel]');
    var tabs = panel && panel.closest('[data-tabs]');
    var btn = tabs && tabs.querySelector('[data-tab="' + panel.dataset.tabPanel + '"]');
    if (btn) btn.click();
    item.scrollIntoView({ block: 'center' });
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    if (!e.target.closest) return;
    var el = e.target.closest('.ideallist__item') || e.target.closest('[data-modal-open]');
    var dialog = el && (el.closest('dialog[data-modal]') || document.getElementById(el.dataset && el.dataset.modalOpen));
    if (dialog && dialog.open) dialog.close();
  });

  /* Theme editor: selecting a step block scrolls it into view. */
  document.addEventListener('shopify:block:select', function (e) {
    var step = e.target.closest && e.target.closest('[data-setup-step]');
    var track = step && step.closest('[data-setup-track]');
    if (track) track.scrollTo({ left: step.offsetLeft - (track.clientWidth - step.offsetWidth) / 2, behavior: 'smooth' });
  });

  /* ---------- Swipeable rows on phones ----------
     The CSS turns marked grids into snap carousels under 750px.
     Here we add the dots and keep them in step with the scrolling. */
  function initMobileCarousels(root) {
    $$('[data-mcarousel]', root).forEach(function (row) {
      if (row.dataset.bound) return;
      row.dataset.bound = '1';

      var items = Array.prototype.filter.call(row.children, function (el) {
        return el.nodeType === 1;
      });
      if (items.length < 2) return;

      var dots = document.createElement('div');
      dots.className = 'mcar-dots';
      items.forEach(function (item, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mcar-dot' + (i === 0 ? ' is-on' : '');
        dot.setAttribute('aria-label', 'Vis ' + (i + 1) + ' av ' + items.length);
        dot.addEventListener('click', function () {
          row.scrollTo({ left: item.offsetLeft - (row.clientWidth - item.offsetWidth) / 2, behavior: 'smooth' });
        });
        dots.appendChild(dot);
      });
      row.parentNode.insertBefore(dots, row.nextSibling);

      var buttons = $$('.mcar-dot', dots);
      var raf;
      row.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var mid = row.scrollLeft + row.clientWidth / 2;
          var best = 0, bestDist = Infinity;
          items.forEach(function (item, i) {
            var d = Math.abs(item.offsetLeft + item.offsetWidth / 2 - mid);
            if (d < bestDist) { bestDist = d; best = i; }
          });
          buttons.forEach(function (b, i) { b.classList.toggle('is-on', i === best); });
        });
      }, { passive: true });
    });
  }

  /* ---------- Handlekurv-skuff ----------
     Innholdet tegnes av seksjonen cart-drawer og hentes ferdig gjengitt fra
     Shopify (Section Rendering API), sa priser, rabatter og gratis gaver alltid
     stemmer med det kassen faktisk ser. */
  var CartDrawer = (function () {
    function rootUrl() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }
    function el() { return $('[data-cart-drawer]'); }

    function open() {
      if (!el()) { window.location.href = rootUrl() + 'cart'; return; }
      document.body.classList.add('cart-open');
      var panel = $('.cdrawer__panel');
      if (panel) panel.focus();
    }

    function close() { document.body.classList.remove('cart-open'); }

    /* Bare innmaten byttes ut: panelet beholder plassen sin og stilarket
       som folger med seksjonen slipper a bli limt inn en gang til. */
    function render(html) {
      var host = el() && el().querySelector('[data-cart-drawer-content]');
      if (!host || !html) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html')
        .querySelector('[data-cart-drawer-content]');
      if (fresh) host.innerHTML = fresh.innerHTML;
    }

    function post(path, data) {
      data.sections = 'cart-drawer';
      data.sections_url = window.location.pathname;
      return fetch(rootUrl() + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(data)
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json && json.sections) render(json.sections['cart-drawer']);
          return json;
        });
    }

    function refresh() {
      return fetch(rootUrl() + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (json) { if (json) render(json['cart-drawer']); });
    }

    return {
      open: open,
      close: close,
      refresh: refresh,
      addItems: function (items) { return post('cart/add.js', { items: items }); },
      change: function (line, quantity) { return post('cart/change.js', { line: line, quantity: quantity }); }
    };
  })();
  window.CartDrawer = CartDrawer;

  function initCartDrawer() {
    if (document.documentElement.dataset.cartDrawerBound) return;
    document.documentElement.dataset.cartDrawerBound = '1';

    /* Delegert, sa knappene virker ogsa etter at innholdet er tegnet om. */
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (target.closest('[data-cart-close]')) { CartDrawer.close(); return; }

      var qtyBtn = target.closest('[data-cart-qty]');
      if (qtyBtn) {
        var line = qtyBtn.closest('[data-cart-line]');
        if (!line) return;
        CartDrawer.change(Number(line.dataset.cartLine), Number(qtyBtn.dataset.cartQty));
        return;
      }

      var addBtn = target.closest('[data-cart-add]');
      if (addBtn) {
        if (addBtn.disabled) return;
        var text = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Lägger till…';
        CartDrawer.addItems([{ id: Number(addBtn.dataset.cartAdd), quantity: 1 }])
          .catch(function () { addBtn.disabled = false; addBtn.textContent = text; });
        return;
      }

      /* Handlekurv-ikonet i toppen apner skuffen i stedet for handlekurvsiden. */
      var cartLink = target.closest('a[href$="/cart"]');
      if (cartLink && $('[data-cart-drawer]')) {
        e.preventDefault();
        CartDrawer.refresh().then(CartDrawer.open);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('cart-open')) CartDrawer.close();
    });
  }

  function initAll(root) {
    initMobileCarousels(root);
    initSetupSteps(root);
    initFeatureTabs(root);
    initAnnounceRotate(root);
    initModals(root);
    initSectionVideos(root);
    initAccordions(root);
    initGalleries(root);
    initBundles(root);
    initCountdowns(root);
    initMenu(root);
    initProductForm(root);
    initCartDrawer();
    initStickyAtc(root);
    initToTop();
    initReviewsMore(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });

  /* Cart drawer timer band: one shared end time per visit (sessionStorage),
     restarts when it reaches 0. The drawer HTML is re-rendered on every change,
     so the tick just looks up [data-cart-timer] each second. */
  (function () {
    function end(min) {
      var key = 'cartTimerEnd', now = Date.now(), t = 0;
      try { t = Number(sessionStorage.getItem(key)) || 0; } catch (e) {}
      if (!t || t <= now) { t = now + min * 60000; try { sessionStorage.setItem(key, t); } catch (e) {} }
      return t;
    }
    setInterval(function () {
      var bar = document.querySelector('[data-cart-timer-bar]');
      if (!bar) return;
      var left = Math.max(0, end(Number(bar.dataset.minutes) || 5) - Date.now());
      var m = Math.floor(left / 60000), sec = Math.floor(left / 1000) % 60;
      document.querySelectorAll('[data-cart-timer]').forEach(function (n) { n.textContent = m + ':' + (sec < 10 ? '0' : '') + sec; });
    }, 1000);
  })();

  /* Theme editor: re-bind whatever the merchant just re-rendered. */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();
